// extracted by css-extract-rspack-plugin
export default {"supportActionsLayout":"support-actions-layout--Iv24xKsRmw836MyI","wideActionCell":"wide-action-cell--utL_POMzNzUSDMYH"};